var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.786 17.847H1.07a1.071 1.071 0 000 2.143h15.715a1.071 1.071 0 000-2.143zm2.587-15.714L17.857.617a2.196 2.196 0 00-3.03 0L5.244 10.2a.714.714 0 00-.197.381l-.761 4.293a.714.714 0 00.714.841.619.619 0 00.124-.011l4.293-.757a.714.714 0 00.382-.199l9.581-9.581a2.143 2.143 0 000-3.03z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.936e7ab5.svg";
export { ForwardRef as ReactComponent };